import { useContext, useMemo } from 'react';
import { DNDContext } from '../contexts/DNDContext';

export function useDNDColumns(columnIds = []) {
	const { DNDState } = useContext(DNDContext);

	return useMemo(() => {
		return DNDState.columns.filter((col) => columnIds.includes(col.id));
	}, [DNDState.columns, columnIds]);
}
